export default __webpack_public_path__ + "static/media/reportsDetails.484752d6.svg";